import { render, staticRenderFns } from "./EditSendExamsTemplate.vue?vue&type=template&id=f092da8a&"
import script from "./EditSendExamsTemplate.vue?vue&type=script&lang=js&"
export * from "./EditSendExamsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports